import type { CSSProperties } from 'react';

export type WalletBalanceVariant = 'header' | 'modal';

interface WalletBalanceVariantStyles {
  container: CSSProperties;
  amount: CSSProperties;
  currency: CSSProperties;
}

/**
 * 'header' matches the original inline styles from GameHeader's balance
 * block. 'modal' is a compact pill meant to sit inline before a modal's
 * close button (SkyxNewModalCloseButton) — same green/muted color logic,
 * denser padding to fit a modal header row.
 */
export const walletBalanceStyles: Record<
  WalletBalanceVariant,
  WalletBalanceVariantStyles
> = {
  header: {
    container: {
      boxSizing: 'border-box',
      height: '28px',
      padding: '0 10px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '4px',
      borderRadius: '999px',
      background: 'rgba(255, 255, 255, 0.06)',
      border: '1px solid rgba(255, 255, 255, 0.12)',
    },
    amount: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '13px',
      fontWeight: 700,
      color: '#13B42E',
      textAlign: 'right',
      fontVariantNumeric: 'lining-nums',
    },
    currency: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '11px',
      fontWeight: 600,
      color: '#ffffff',
      letterSpacing: '-.1px',
      textAlign: 'right',
    },
  },
  modal: {
    container: {
      boxSizing: 'border-box',
      height: '32px',
      padding: '0px 10px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '4px',
      borderRadius: '999px',
      background: 'transparent',
      border: '1px solid rgba(147, 92, 255, 0.5)',
    },
    amount: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '13px',
      fontWeight: 700,
      color: '#13B42E',
      textAlign: 'right',
      fontVariantNumeric: 'lining-nums',
    },
    currency: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '11px',
      fontWeight: 600,
      color: '#ffffff',
      letterSpacing: '-.1px',
      textAlign: 'right',
    },
  },
};
